import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../../Base/Components/BaseModal/BaseModal';
import EArchiveGroupSettingsActionsUpdateForm from './EArchiveGroupSettingsActionsUpdateForm';
import { UpdateGroupInput } from '../../../../../../graphql/graphql';

interface Props extends BaseModalProps {
	groupId: string;
	onSubmit: (values: UpdateGroupInput) => void;
}

const EArchiveGroupSettingsActionsUpdateModal = ({
	onSubmit,
	groupId,
	...modalProps
}: Props) => {
	return (
		<BaseModal
			{...modalProps}
			title={'component.eArchive.group.settings.changeGroupTitle'}>
			<EArchiveGroupSettingsActionsUpdateForm
				groupId={groupId}
				onSubmit={onSubmit}
			/>
		</BaseModal>
	);
};

export default EArchiveGroupSettingsActionsUpdateModal;
